// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular.module('landingPage').directive('giToggleText', () => ({
  restrict: 'A',

  link(scope, element, attrs) {
    element.bind('click', function () {
      let addToElement = element;
      if (attrs.giToggleText !== '') {
        addToElement = eval(attrs.giToggleText);
      }

      if (addToElement.hasClass('description-open') === true) {
        return addToElement.removeClass('description-open');
      } else {
        return addToElement.addClass('description-open');
      }
    });
  },
}));
